import request from '@/utils/request'

/**
 * 获取资源列表
 * @param query
 */
export function fetchList(query) {
	return request({
		url: '/api/resource/list ',
		method: 'post',
		data: query
	})
}

/**
 * 保存资源
 * @param param
 */
export function save(param) {
	return request({
		url: '/api/resource/save',
		method: 'post',
		data: param
	})
}

/**
 * 修改资源
 * @param param
 */
export function update(param) {
	return request({
		url: '/api/resource/update',
		method: 'post',
		data: param
	})
}

/**
 *删除资源
 * @param param
 */
export function remove(param) {
	return request({
		url: '/api/resource/delete/' + param,
		method: 'post'
	})
}

/**
 * 获取单个资源基本信息
 * @param param
 */
export function get(param) {
	return request({
		url: '/api/resource/view/' + param,
		method: 'get'
	})
}

/**
 * 获取树形列表数据
 * @param query
 */
export function tree(query) {
	return request({
		url: '/api/resource/tree',
		method: 'get',
		data: query
	})
}
/**
 * 获取菜单列表数据
 * @param query
 */
export function menus(query) {
	return request({
		url: '/api/resource/menus',
		method: 'post',
		data: query
	})
}
